import type { ReactNode } from 'react';
import { cx } from './cx';

export type NoticeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export function Notice({
  tone = 'neutral', title, children, live,
}: {
  tone?: NoticeTone;
  title?: string;
  children: ReactNode;
  /** Só quando o aviso APARECE em resposta a uma ação. Um `role="alert"` que
   *  já existe na carga da página é lido junto com o resto e vira ruído. */
  live?: boolean;
}) {
  return (
    <div
      className={cx('notice', tone !== 'neutral' && `notice--${tone}`)}
      role={live ? 'alert' : undefined}
    >
      <div>
        {title && <p className="notice__title">{title}</p>}
        <div>{children}</div>
      </div>
    </div>
  );
}
